var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "dropdown",
      staticClass: "dropdown",
      class: { "in-input-set": _vm.inInputSet },
    },
    [
      _vm.label
        ? _c("label", { staticClass: "dropdown-label" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "toggler",
          staticClass: "toggler noselect",
          class: {
            "disabled ": _vm.disabled,
            togglerDropdown: _vm.isNavbarDropdown,
            active: _vm.active,
            error: _vm.error,
          },
          attrs: {
            title: _vm.dropdownTitle,
            tabindex: _vm.tabIndex,
            name: _vm.name,
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggle.apply(null, arguments)
            },
            blur: _vm.onBlurToggler,
            focus: _vm.onFocusToggler,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "arrow-down",
                    undefined,
                    $event.key,
                    undefined
                  )
                )
                  return null
                $event.preventDefault()
                return _vm.navigateList("down")
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "arrow-up",
                    undefined,
                    $event.key,
                    undefined
                  )
                )
                  return null
                $event.preventDefault()
                return _vm.navigateList("up")
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                )
                  return null
                return _vm.onTabToggler.apply(null, arguments)
              },
            ],
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.onEnter.apply(null, arguments)
            },
          },
        },
        [
          _c("div", {
            class: {
              spanDropdown: _vm.isNavbarDropdown,
              placeholderActive: _vm.placeholderActive,
              "option-selected": true,
            },
            domProps: {
              innerHTML: _vm._s(_vm.formatText(_vm.mocked_selected)),
            },
          }),
          _vm._v(" "),
          !_vm.disabled
            ? _c("div", [
                !_vm.toggled
                  ? _c("i", { staticClass: "fas fa-angle-down" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.toggled
                  ? _c("i", { staticClass: "fas fa-angle-up" })
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: ["menu", { toggled: _vm.toggled }] },
        [
          _vm.searchable
            ? _c("div", { staticClass: "search-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search",
                    },
                  ],
                  staticClass: "filter",
                  attrs: {
                    placeholder: _vm.filterPlaceholder,
                    title: _vm.filterTitle,
                  },
                  domProps: { value: _vm.search },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.search = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("i", { staticClass: "fa fa-search search-icon" }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.displayed, function (entry, i) {
            return _c("div", {
              key: i,
              staticClass: "items",
              class: { hovered: _vm.focusedItem === entry },
              attrs: { id: "item-" + i },
              domProps: { innerHTML: _vm._s(_vm.formatText(entry)) },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.itemClick(entry)
                },
                mouseover: function ($event) {
                  return _vm.itemMouseOver(entry)
                },
              },
            })
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }